
  //   import axios from 'axios';

  //   const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net';

  //   const api = axios.create({
  //     baseURL: API_BASE,
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   });

  //   // Request Interceptor — attach token + cache busting for GET only
  //   api.interceptors.request.use(
  //     (config) => {
  //       const token = localStorage.getItem('token');
  //       if (token) {
  //         config.headers.Authorization = `Bearer ${token}`;
  //       }

  //       config.headers['Cache-Control'] = 'no-cache';
  //       config.headers['Pragma'] = 'no-cache';

  //       // Only add _t timestamp to GET requests (not POST/PUT/DELETE)
  //       if (config.method === 'get') {
  //         config.params = {
  //           ...config.params,
  //           _t: new Date().getTime()
  //         };
  //       }

  //       return config;
  //     },
  //     (error) => Promise.reject(error)
  //   );

  //   // Response Interceptor — handle 401 globally
  //   api.interceptors.response.use(
  //     (response) => response,
  //     (error) => {
  //       console.error('API Error:', error.response?.data?.error || error.message);
  //       if (error.response?.status === 401) {
  //         // Don't redirect if already on login page
  //         if (!window.location.pathname.includes('/login')) {
  //           localStorage.clear();
  //           window.location.href = '/login';
  //         }
  //       }
  //       return Promise.reject(error);
  //     }
  //   );

  // // ========================================
  // // AUTHENTICATION
  // // ========================================
  // export const login = (username, password) =>
  //   api.post('/auth', { username, password }).then((response) => {
  //     if (response.data.success) {
  //       localStorage.setItem('token', response.data.token);
  //       localStorage.setItem('user_id', response.data.user_id);
  //       localStorage.setItem('role', response.data.role);
  //       localStorage.setItem('username', response.data.username);
  //       localStorage.setItem('email', response.data.email);
  //       localStorage.setItem('employee_name', response.data.employee_name || '');
  //       localStorage.setItem('employee_code', response.data.employee_code || '');
  //     }
  //     return response;
  //   });

  // // NEW: Forgot Password
  // export const forgotPassword = (email) => {
  //   return api.post('/auth/forgot-password', { email });
  // };

  // // NEW: Reset Password (from email link)
  // export const resetPassword = (token, password) => {
  //   return api.post(`/auth/reset-password/${token}`, { password });
  // };

  // export const logout = () => {
  //   localStorage.clear();
  //   window.location.href = '/login';
  //   return Promise.resolve();
  // };

  // export const register = (data) => api.post('/auth/register', data);

  // // ========================================
  // // PACKAGES
  // // ========================================
  // export const getPackages = () => 
  //   api.get('/packages', {
  //     headers: {
  //       'Cache-Control': 'no-cache'
  //     }
  //   });
  // export const getPackage = (reference_id) => 
  //   api.get(`/packages/${reference_id}/view`);

  // export const submitPackage = async (user_id, payload) => {
  //   const {
  //     data,
  //     currency,
  //     convertedCurrency,
  //     exchangeRate,
  //     assignedApproverId,   // ← Fixed: renamed
  //     approverRole          // ← Fixed: new field
  //   } = payload;

  //   const fieldsToConvert = [
  //     'Mark-up',
  //     'Per Pax Selling Price',
  //     'Less: Agent Commission',
  //     'Less: Transaction Charges',
  //     'Gross Margin'
  //   ];

  //   const finalData = { ...data };

  //   if (convertedCurrency && convertedCurrency !== currency && exchangeRate > 0) {
  //     const rate = parseFloat(exchangeRate);

  //     fieldsToConvert.forEach(field => {
  //       const originalValue = parseFloat(data[field]) || 0;
  //       const convertedValue = originalValue * rate;

  //       finalData[field] = originalValue;
  //       finalData[`Converted ${field}`] = parseFloat(convertedValue.toFixed(2));
  //     });

  //     finalData['Conversion Rate Used'] = `1 ${currency} = ${exchangeRate} ${convertedCurrency}`;
  //     finalData['Converted Currency'] = convertedCurrency;
  //   }

  //   return api.post('/packages', {
  //     user_id,
  //     data: finalData,
  //     currency,
  //     convertedCurrency: convertedCurrency || null,
  //     assigned_approver_id: assignedApproverId,   // ← matches DB column name
  //     approver_role: approverRole                 // ← new column
  //   });
  // };
  // export const resubmitPackage = (reference_id, payload) => 
  //   api.put(`/packages/${reference_id}/resubmit`, payload);
  // // NEW: Get managers for dropdown
  // export const getManagers = () => api.get('/managers');

  // // NEW: Get package history
  // export const getPackageHistory = (reference_id) => 
  //   api.get(`/packages/${reference_id}/history`);

  // // NEW: Get package activity logs
  // export const getPackageActivity = (reference_id) => 
  //   api.get(`/packages/${reference_id}/activity`);

  // export const approvePackage = (reference_id, role) =>
  //   api.put(`/packages/${reference_id}`, { action: 'approve', role });

  // export const rejectPackage = (reference_id, role) =>
  //   api.put(`/packages/${reference_id}`, { action: 'reject', role });

  // // UPDATED: Delete package (Functional Admin only)
  // export const deletePackage = (reference_id) =>
  //   api.delete(`/packages/${reference_id}`);

  // // ========================================
  // // FORM FIELDS
  // // ========================================
  // export const getFormFields = () => api.get('/form_fields');
  // export const addFormField = (field) => api.post('/form_fields', field);
  // export const updateFormField = (id, field) =>
  //   api.put('/form_fields', field, { params: { id } });
  // export const deleteFormField = (id) =>
  //   api.delete('/form_fields', { params: { id } });

  // // ========================================
  // // USERS & DASHBOARD
  // // ========================================
  // export const getStats = () => api.get('/stats');

  // // NEW: Admin dashboard stats
  // export const getAdminDashboardStats = () => api.get('/admin/dashboard-stats');

  // // NEW: Admin activity logs
  // export const getAdminActivityLogs = () => api.get('/admin/activity-logs');

  // export const getUsers = () => api.get('/users');
  // export const updateUser = (id, userData) => api.put(`/users/${id}`, userData);
  // export const deleteUser = (id) => api.delete(`/users/${id}`);

  // // ========================================
  // // NOTIFICATIONS
  // // ========================================
  // export const sendNotification = async (notificationData) => {
  //   try {
  //     const response = await api.post('/notifications/send', notificationData);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error sending notification:', error);
  //     throw error;
  //   }
  // };

  // // ========================================
  // // EXCHANGE RATES (Fallback to Public API)
  // // ========================================
  // export const fetchRatesApi = async () => {
  //   try {
  //     const res = await fetch('https://open.er-api.com/v6/latest/USD');
  //     if (!res.ok) throw new Error('Network response was not ok');
  //     const data = await res.json();
  //     return data.result === 'success' ? data.rates : {};
  //   } catch (error) {
  //     console.error('Error fetching exchange rates:', error.message);
  //     return {};
  //   }
  // };
  // export const getFunctionalAdmins = () => api.get('/functional_admins');
  // // NEW: Public package view (No authentication required)
  // export const getPublicPackage = (refId) => 
  //   api.get(`/packages/public/${refId}`);

  // // NEW: Health check
  // export const checkHealth = () => api.get('/health');

  // export default api;

//   import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net';

// const api = axios.create({
//   baseURL: API_BASE,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request Interceptor — attach token + cache busting for GET only
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     config.headers['Cache-Control'] = 'no-cache';
//     config.headers['Pragma'] = 'no-cache';

//     // Only add _t timestamp to GET requests (not POST/PUT/DELETE)
//     if (config.method === 'get') {
//       config.params = {
//         ...config.params,
//         _t: new Date().getTime()
//       };
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error('API Error:', error.response?.data?.error || error.message);
//     if (error.response?.status === 401) {
//       // Don't redirect if already on login page
//       if (!window.location.pathname.includes('/login')) {
//         localStorage.clear();
//         window.location.href = '/login';
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// // ========================================
// // AUTHENTICATION
// // ========================================
// export const login = (username, password) =>
//   api.post('/auth', { username, password }).then((response) => {
//     if (response.data.success) {
//       localStorage.setItem('token', response.data.token);
//       localStorage.setItem('user_id', response.data.user_id);
//       localStorage.setItem('role', response.data.role);
//       localStorage.setItem('username', response.data.username);
//       localStorage.setItem('email', response.data.email);
//       localStorage.setItem('employee_name', response.data.employee_name || '');
//       localStorage.setItem('employee_code', response.data.employee_code || '');
//     }
//     return response;
//   });

// // Forgot Password
// export const forgotPassword = (email) => {
//   return api.post('/auth/forgot-password', { email });
// };

// // Reset Password (from email link)
// export const resetPassword = (token, password) => {
//   return api.post(`/auth/reset-password/${token}`, { password });
// };

// export const logout = () => {
//   localStorage.clear();
//   window.location.href = '/login';
//   return Promise.resolve();
// };

// export const register = (data) => api.post('/auth/register', data);

// // ========================================
// // PACKAGES
// // ========================================
// export const getPackages = () =>
//   api.get('/packages', {
//     headers: {
//       'Cache-Control': 'no-cache'
//     }
//   });

// export const getPackage = (reference_id) =>
//   api.get(`/packages/${reference_id}/view`);

// export const submitPackage = async (user_id, payload) => {
//   const {
//     data,
//     currency,
//     convertedCurrency,
//     exchangeRate,
//     // Accept both camelCase and snake_case — form sends both as fallback
//     assignedApproverId,
//     assigned_approver_id,
//     approverRole,
//     approver_role,
//   } = payload;

//   // Resolve approver id and role regardless of which key was sent
//   const resolvedApproverId = assignedApproverId || assigned_approver_id;
//   const resolvedApproverRole = approverRole || approver_role;

//   const fieldsToConvert = [
//     'Mark-up',
//     'Per Pax Selling Price',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   const finalData = { ...data };

//   // Only apply conversion if currencies differ and rate is valid
//   const rate = parseFloat(exchangeRate);
//   const shouldConvert =
//     convertedCurrency &&
//     convertedCurrency !== currency &&
//     !isNaN(rate) &&
//     rate > 0;

//   if (shouldConvert) {
//     fieldsToConvert.forEach(field => {
//       const originalValue = parseFloat(data[field]) || 0;
//       const convertedValue = parseFloat((originalValue * rate).toFixed(2));

//       finalData[field] = originalValue;                      // keep original in main currency
//       finalData[`Converted ${field}`] = convertedValue;     // store converted value
//     });

//     finalData['Conversion Rate Used'] = `1 ${currency} = ${rate.toFixed(4)} ${convertedCurrency}`;
//     finalData['Converted Currency'] = convertedCurrency;
//     finalData['Main Currency'] = currency;
//   }

//   return api.post('/packages', {
//     user_id,
//     data: finalData,
//     currency,
//     convertedCurrency: convertedCurrency || null,
//     exchange_rate: shouldConvert ? rate : null,            // snake_case for DB consistency
//     assigned_approver_id: resolvedApproverId,
//     approver_role: resolvedApproverRole,
//   });
// };

// export const resubmitPackage = (reference_id, payload) =>
//   api.put(`/packages/${reference_id}/resubmit`, payload);

// // Get managers for dropdown
// export const getManagers = () => api.get('/managers');

// // Get functional admins for dropdown
// export const getFunctionalAdmins = () => api.get('/functional_admins');

// // Get package history
// export const getPackageHistory = (reference_id) =>
//   api.get(`/packages/${reference_id}/history`);

// // Get package activity logs
// export const getPackageActivity = (reference_id) =>
//   api.get(`/packages/${reference_id}/activity`);

// export const approvePackage = (reference_id, role) =>
//   api.put(`/packages/${reference_id}`, { action: 'approve', role });

// export const rejectPackage = (reference_id, role) =>
//   api.put(`/packages/${reference_id}`, { action: 'reject', role });

// // Delete package (Functional Admin only)
// export const deletePackage = (reference_id) =>
//   api.delete(`/packages/${reference_id}`);

// // ========================================
// // FORM FIELDS
// // ========================================
// export const getFormFields = () => api.get('/form_fields');
// export const addFormField = (field) => api.post('/form_fields', field);
// export const updateFormField = (id, field) =>
//   api.put('/form_fields', field, { params: { id } });
// export const deleteFormField = (id) =>
//   api.delete('/form_fields', { params: { id } });

// // ========================================
// // USERS & DASHBOARD
// // ========================================
// export const getStats = () => api.get('/stats');

// // Admin dashboard stats
// export const getAdminDashboardStats = () => api.get('/admin/dashboard-stats');

// // Admin activity logs
// export const getAdminActivityLogs = () => api.get('/admin/activity-logs');

// export const getUsers = () => api.get('/users');
// export const updateUser = (id, userData) => api.put(`/users/${id}`, userData);
// export const deleteUser = (id) => api.delete(`/users/${id}`);

// // ========================================
// // NOTIFICATIONS
// // ========================================
// export const sendNotification = async (notificationData) => {
//   try {
//     const response = await api.post('/notifications/send', notificationData);
//     return response.data;
//   } catch (error) {
//     console.error('Error sending notification:', error);
//     throw error;
//   }
// };

// // ========================================
// // EXCHANGE RATES
// // ========================================
// export const fetchRatesApi = async () => {
//   try {
//     // Rates returned are all relative to USD base
//     // To convert A → B: value * (rates[B] / rates[A])
//     const res = await fetch('https://open.er-api.com/v6/latest/USD');
//     if (!res.ok) throw new Error('Network response was not ok');
//     const data = await res.json();
//     return data.result === 'success' ? data.rates : {};
//   } catch (error) {
//     console.error('Error fetching exchange rates:', error.message);
//     return {};
//   }
// };

// // Public package view (No authentication required)
// export const getPublicPackage = (refId) =>
//   api.get(`/packages/public/${refId}`);

// // Health check
// export const checkHealth = () => api.get('/health');

// export default api;
//   import axios from 'axios';

  //   const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net';

  //   const api = axios.create({
  //     baseURL: API_BASE,
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   });

  //   // Request Interceptor — attach token + cache busting for GET only
  //   api.interceptors.request.use(
  //     (config) => {
  //       const token = localStorage.getItem('token');
  //       if (token) {
  //         config.headers.Authorization = `Bearer ${token}`;
  //       }

  //       config.headers['Cache-Control'] = 'no-cache';
  //       config.headers['Pragma'] = 'no-cache';

  //       // Only add _t timestamp to GET requests (not POST/PUT/DELETE)
  //       if (config.method === 'get') {
  //         config.params = {
  //           ...config.params,
  //           _t: new Date().getTime()
  //         };
  //       }

  //       return config;
  //     },
  //     (error) => Promise.reject(error)
  //   );

  //   // Response Interceptor — handle 401 globally
  //   api.interceptors.response.use(
  //     (response) => response,
  //     (error) => {
  //       console.error('API Error:', error.response?.data?.error || error.message);
  //       if (error.response?.status === 401) {
  //         // Don't redirect if already on login page
  //         if (!window.location.pathname.includes('/login')) {
  //           localStorage.clear();
  //           window.location.href = '/login';
  //         }
  //       }
  //       return Promise.reject(error);
  //     }
  //   );

  // // ========================================
  // // AUTHENTICATION
  // // ========================================
  // export const login = (username, password) =>
  //   api.post('/auth', { username, password }).then((response) => {
  //     if (response.data.success) {
  //       localStorage.setItem('token', response.data.token);
  //       localStorage.setItem('user_id', response.data.user_id);
  //       localStorage.setItem('role', response.data.role);
  //       localStorage.setItem('username', response.data.username);
  //       localStorage.setItem('email', response.data.email);
  //       localStorage.setItem('employee_name', response.data.employee_name || '');
  //       localStorage.setItem('employee_code', response.data.employee_code || '');
  //     }
  //     return response;
  //   });

  // // NEW: Forgot Password
  // export const forgotPassword = (email) => {
  //   return api.post('/auth/forgot-password', { email });
  // };

  // // NEW: Reset Password (from email link)
  // export const resetPassword = (token, password) => {
  //   return api.post(`/auth/reset-password/${token}`, { password });
  // };

  // export const logout = () => {
  //   localStorage.clear();
  //   window.location.href = '/login';
  //   return Promise.resolve();
  // };

  // export const register = (data) => api.post('/auth/register', data);

  // // ========================================
  // // PACKAGES
  // // ========================================
  // export const getPackages = () => 
  //   api.get('/packages', {
  //     headers: {
  //       'Cache-Control': 'no-cache'
  //     }
  //   });
  // export const getPackage = (reference_id) => 
  //   api.get(`/packages/${reference_id}/view`);

  // export const submitPackage = async (user_id, payload) => {
  //   const {
  //     data,
  //     currency,
  //     convertedCurrency,
  //     exchangeRate,
  //     assignedApproverId,   // ← Fixed: renamed
  //     approverRole          // ← Fixed: new field
  //   } = payload;

  //   const fieldsToConvert = [
  //     'Mark-up',
  //     'Per Pax Selling Price',
  //     'Less: Agent Commission',
  //     'Less: Transaction Charges',
  //     'Gross Margin'
  //   ];

  //   const finalData = { ...data };

  //   if (convertedCurrency && convertedCurrency !== currency && exchangeRate > 0) {
  //     const rate = parseFloat(exchangeRate);

  //     fieldsToConvert.forEach(field => {
  //       const originalValue = parseFloat(data[field]) || 0;
  //       const convertedValue = originalValue * rate;

  //       finalData[field] = originalValue;
  //       finalData[`Converted ${field}`] = parseFloat(convertedValue.toFixed(2));
  //     });

  //     finalData['Conversion Rate Used'] = `1 ${currency} = ${exchangeRate} ${convertedCurrency}`;
  //     finalData['Converted Currency'] = convertedCurrency;
  //   }

  //   return api.post('/packages', {
  //     user_id,
  //     data: finalData,
  //     currency,
  //     convertedCurrency: convertedCurrency || null,
  //     assigned_approver_id: assignedApproverId,   // ← matches DB column name
  //     approver_role: approverRole                 // ← new column
  //   });
  // };
  // export const resubmitPackage = (reference_id, payload) => 
  //   api.put(`/packages/${reference_id}/resubmit`, payload);
  // // NEW: Get managers for dropdown
  // export const getManagers = () => api.get('/managers');

  // // NEW: Get package history
  // export const getPackageHistory = (reference_id) => 
  //   api.get(`/packages/${reference_id}/history`);

  // // NEW: Get package activity logs
  // export const getPackageActivity = (reference_id) => 
  //   api.get(`/packages/${reference_id}/activity`);

  // export const approvePackage = (reference_id, role) =>
  //   api.put(`/packages/${reference_id}`, { action: 'approve', role });

  // export const rejectPackage = (reference_id, role) =>
  //   api.put(`/packages/${reference_id}`, { action: 'reject', role });

  // // UPDATED: Delete package (Functional Admin only)
  // export const deletePackage = (reference_id) =>
  //   api.delete(`/packages/${reference_id}`);

  // // ========================================
  // // FORM FIELDS
  // // ========================================
  // export const getFormFields = () => api.get('/form_fields');
  // export const addFormField = (field) => api.post('/form_fields', field);
  // export const updateFormField = (id, field) =>
  //   api.put('/form_fields', field, { params: { id } });
  // export const deleteFormField = (id) =>
  //   api.delete('/form_fields', { params: { id } });

  // // ========================================
  // // USERS & DASHBOARD
  // // ========================================
  // export const getStats = () => api.get('/stats');

  // // NEW: Admin dashboard stats
  // export const getAdminDashboardStats = () => api.get('/admin/dashboard-stats');

  // // NEW: Admin activity logs
  // export const getAdminActivityLogs = () => api.get('/admin/activity-logs');

  // export const getUsers = () => api.get('/users');
  // export const updateUser = (id, userData) => api.put(`/users/${id}`, userData);
  // export const deleteUser = (id) => api.delete(`/users/${id}`);

  // // ========================================
  // // NOTIFICATIONS
  // // ========================================
  // export const sendNotification = async (notificationData) => {
  //   try {
  //     const response = await api.post('/notifications/send', notificationData);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error sending notification:', error);
  //     throw error;
  //   }
  // };

  // // ========================================
  // // EXCHANGE RATES (Fallback to Public API)
  // // ========================================
  // export const fetchRatesApi = async () => {
  //   try {
  //     const res = await fetch('https://open.er-api.com/v6/latest/USD');
  //     if (!res.ok) throw new Error('Network response was not ok');
  //     const data = await res.json();
  //     return data.result === 'success' ? data.rates : {};
  //   } catch (error) {
  //     console.error('Error fetching exchange rates:', error.message);
  //     return {};
  //   }
  // };
  // export const getFunctionalAdmins = () => api.get('/functional_admins');
  // // NEW: Public package view (No authentication required)
  // export const getPublicPackage = (refId) => 
  //   api.get(`/packages/public/${refId}`);

  // // NEW: Health check
  // export const checkHealth = () => api.get('/health');

  // export default api;

  import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor — attach token + cache busting for GET only
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';

    // Only add _t timestamp to GET requests (not POST/PUT/DELETE)
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: new Date().getTime()
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor — handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data?.error || error.message);
    if (error.response?.status === 401) {
      // Don't redirect if already on login page
      if (!window.location.pathname.includes('/login')) {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ========================================
// AUTHENTICATION
// ========================================
export const login = (username, password) =>
  api.post('/auth', { username, password }).then((response) => {
    if (response.data.success) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user_id', response.data.user_id);
      localStorage.setItem('role', response.data.role);
      localStorage.setItem('username', response.data.username);
      localStorage.setItem('email', response.data.email);
      localStorage.setItem('employee_name', response.data.employee_name || '');
      localStorage.setItem('employee_code', response.data.employee_code || '');
    }
    return response;
  });

// Forgot Password
export const forgotPassword = (email) => {
  return api.post('/auth/forgot-password', { email });
};

// Reset Password (from email link)
export const resetPassword = (token, password) => {
  return api.post(`/auth/reset-password/${token}`, { password });
};

export const logout = () => {
  localStorage.clear();
  window.location.href = '/login';
  return Promise.resolve();
};

export const register = (data) => api.post('/auth/register', data);

// ========================================
// PACKAGES
// ========================================
export const getPackages = () =>
  api.get('/packages', {
    headers: {
      'Cache-Control': 'no-cache'
    }
  });

export const getPackage = (reference_id) =>
  api.get(`/packages/${reference_id}/view`);

export const submitPackage = async (user_id, payload) => {
  const {
    data,
    currency,
    convertedCurrency,
    exchangeRate,
    // Accept both camelCase and snake_case — form sends both as fallback
    assignedApproverId,
    assigned_approver_id,
    approverRole,
    approver_role,
  } = payload;

  // Resolve approver id and role regardless of which key was sent
  const resolvedApproverId = assignedApproverId || assigned_approver_id;
  const resolvedApproverRole = approverRole || approver_role;

  const fieldsToConvert = [
    'Mark-up',
    'Per Pax Selling Price',
    'Less: Agent Commission',
    'Less: Transaction Charges',
    'Gross Margin'
  ];

  const finalData = { ...data };

  // Only apply conversion if currencies differ and rate is valid
  const rate = parseFloat(exchangeRate);
  const shouldConvert =
    convertedCurrency &&
    convertedCurrency !== currency &&
    !isNaN(rate) &&
    rate > 0;

  if (shouldConvert) {
    fieldsToConvert.forEach(field => {
      const originalValue = parseFloat(data[field]) || 0;
      const convertedValue = parseFloat((originalValue * rate).toFixed(2));

      finalData[field] = originalValue;                      // keep original in main currency
      finalData[`Converted ${field}`] = convertedValue;     // store converted value
    });

    finalData['Conversion Rate Used'] = `1 ${currency} = ${rate.toFixed(4)} ${convertedCurrency}`;
    finalData['Converted Currency'] = convertedCurrency;
    finalData['Main Currency'] = currency;
  }

  return api.post('/packages', {
    user_id,
    data: finalData,
    currency,
    convertedCurrency: convertedCurrency || null,
    exchange_rate: shouldConvert ? rate : null,            // snake_case for DB consistency
    assigned_approver_id: resolvedApproverId,
    approver_role: resolvedApproverRole,
  });
};

export const resubmitPackage = (reference_id, payload) =>
  api.put(`/packages/${reference_id}/resubmit`, payload);

// Get managers for dropdown
export const getManagers = () => api.get('/managers');

// Get functional admins for dropdown
export const getFunctionalAdmins = () => api.get('/functional_admins');

// Get package history
export const getPackageHistory = (reference_id) =>
  api.get(`/packages/${reference_id}/history`);

// Get package activity logs
export const getPackageActivity = (reference_id) =>
  api.get(`/packages/${reference_id}/activity`);

export const approvePackage = (reference_id, role) =>
  api.put(`/packages/${reference_id}`, { action: 'approve', role });

export const rejectPackage = (reference_id, role) =>
  api.put(`/packages/${reference_id}`, { action: 'reject', role });

// Delete package (Functional Admin only)
export const deletePackage = (reference_id) =>
  api.delete(`/packages/${reference_id}`);

// ========================================
// FORM FIELDS
// ========================================
export const getFormFields = () => api.get('/form_fields');
export const addFormField = (field) => api.post('/form_fields', field);
export const updateFormField = (id, field) =>
  api.put('/form_fields', field, { params: { id } });
export const deleteFormField = (id) =>
  api.delete('/form_fields', { params: { id } });

// ========================================
// USERS & DASHBOARD
// ========================================
export const getStats = () => api.get('/stats');

// Admin dashboard stats
export const getAdminDashboardStats = () => api.get('/admin/dashboard-stats');

// Admin activity logs
export const getAdminActivityLogs = () => api.get('/admin/activity-logs');

export const getUsers = () => api.get('/users');
export const updateUser = (id, userData) => api.put(`/users/${id}`, userData);
export const deleteUser = (id) => api.delete(`/users/${id}`);

// ========================================
// NOTIFICATIONS
// ========================================
export const sendNotification = async (notificationData) => {
  try {
    const response = await api.post('/notifications/send', notificationData);
    return response.data;
  } catch (error) {
    console.error('Error sending notification:', error);
    throw error;
  }
};

// ========================================
// EXCHANGE RATES
// ========================================
export const fetchRatesApi = async () => {
  // Static fallback rates (USD-base) — used when both APIs fail or miss a currency
  // MUR rate approx 2025: 1 USD ~ 46.5 MUR
  const STATIC_FALLBACK = {
    USD: 1, INR: 83.5, EUR: 0.92, GBP: 0.79, AED: 3.67,
    JPY: 149.5, CAD: 1.36, AUD: 1.53, SGD: 1.34, CHF: 0.90,
    THB: 35.1, MYR: 4.72, ZAR: 18.6, NZD: 1.63, SAR: 3.75,
    HKD: 7.82, IDR: 15700, LKR: 325, VND: 24500, KHR: 4100,
    PHP: 56.5, MUR: 46.5,
  };

  // Primary: open.er-api.com — free, no key, covers MUR + 150+ currencies
  try {
    const res = await fetch('https://open.er-api.com/v6/latest/USD');
    if (res.ok) {
      const data = await res.json();
      if (data.result === 'success' && data.rates) {
        return { ...STATIC_FALLBACK, ...data.rates };
      }
    }
  } catch (err) {
    console.warn('open.er-api failed, trying fxapi:', err.message);
  }

  // Secondary: fxapi.app
  try {
    const res = await fetch('https://open.er-api.com/v6/latest/USD');
    if (res.ok) {
      const data = await res.json();
      if (data.rates) {
        return { ...STATIC_FALLBACK, ...data.rates };
      }
    }
  } catch (err) {
    console.warn('fxapi also failed, using static fallback:', err.message);
  }

  // Last resort: static rates
  return STATIC_FALLBACK;
};


// Public package view (No authentication required)
export const getPublicPackage = (refId) =>
  api.get(`/packages/public/${refId}`);

// Health check
export const checkHealth = () => api.get('/health');

export default api;